import {
  isToastLabPresetId,
  parseToastLabAction,
  TOAST_LAB_DEFAULT_DURATION_MS,
  TOAST_LAB_PRESETS,
  type ToastLabAction,
  type ToastLabPresetId,
} from '@/visual-lab/chapters/toast/toastLabPresets';

export type ToastLabQueryState = {
  preset?: ToastLabPresetId;
  action: ToastLabAction;
  duration: number;
  title: string;
  message: string;
  shouldAutoShow: boolean;
};

function parseDuration(raw: string | null): number {
  if (!raw) {
    return TOAST_LAB_DEFAULT_DURATION_MS;
  }
  const parsed = Number.parseInt(raw, 10);
  if (Number.isNaN(parsed) || parsed <= 0) {
    return TOAST_LAB_DEFAULT_DURATION_MS;
  }
  return parsed;
}

/**
 * Reads toast lab controls from `window.location.search` query params.
 */
export function parseToastLabQuery(search: string): ToastLabQueryState {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const presetParam = params.get('preset');
  const preset = isToastLabPresetId(presetParam) ? presetParam : undefined;
  const presetValues = preset ? TOAST_LAB_PRESETS[preset] : undefined;

  const messageParam = params.get('message');
  const titleParam = params.get('title');
  const actionParam = parseToastLabAction(params.get('action'));

  const message = messageParam ?? presetValues?.message ?? '';
  const title = titleParam ?? presetValues?.title ?? '';
  const action = actionParam ?? presetValues?.action ?? 'error';
  const duration = parseDuration(params.get('duration'));

  return {
    preset,
    action,
    duration,
    title,
    message,
    shouldAutoShow: Boolean(preset || messageParam),
  };
}
